<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img28.jpg"/></p>
<p class="chap"><a id="ch13"></a>JOHN ROLFE, 1615</p>
<p class="noindent"><span class="big">O</span>ften overlooked because of Pocahontas, his more famous wife, planter John Rolfe discovered the key to Jamestown’s economic survival. Rolfe and others knew that if Virginia was to truly prosper it had to find a cash crop. Sometime around 1612, he began experimenting with <i>Nicotiana tabacum</i>, a sweet strain of tobacco imported from the Caribbean. In early summer 1613, he sent a small shipment of this aromatic weed back to England. It instantly caught on and eventually proved Virginia’s salvation.</p>
<p class="indent">Two years after their marriage, tragedy struck the couple. At the end of a triumphant recruitment tour of England, Pocahontas died, probably of respiratory complications due to the cooler and more moist climate in England. Upon his return, Rolfe received a number of rich land grants. During the Powhatan uprising in 1622, his holdings at Bermuda Hundred were destroyed. He may have died during the attack, but whatever his end, John Rolfe played a leading role in the commercial, social, and diplomatic life of first-decade Jamestown. <span class="color">(12-055, 12-056)</span></p>
<p class="image"><img alt="image" src="images/img29.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter013.vue?9eb03690